import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {BrowserRouter} from 'react-router-dom';
import AppLocalizationProvider from './AppLocalizationProvider';
import './index.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { APIContext, createAPI } from './apiv1';
import Redux from './components/logic/Redux';

if (process.env.REACT_APP_API_PREFIX === undefined) {
	throw new Error("Improperly configured frontend! REACT_APP_API_PREFIX not set");
}

// We want to be able to generate one frontend docker container that will work
// for both production and staging. The environment variables are bundled with
// the app at compile time, so we can't pass different environment variables
// for the different environments. As a workaround, we allow the prefix to
// contain '@domain', which will be replaced by the domain name the frontend is
// served with, usually either mitberedskab.dk or mitberedskabstaging.dk.
const domainMatch = window.location.host.match(/[^\.]+\.[^\.]+$/);
const domain = domainMatch ? domainMatch[0] : window.location.host;
const apiPrefix = process.env.REACT_APP_API_PREFIX.replace("@domain", domain);

const api  = createAPI((endpoint, init) =>
	fetch(apiPrefix + endpoint, {
		...init,
		credentials: 'include',
		mode: 'cors'
	}));

ReactDOM.render(
	<StrictMode>
		<APIContext.Provider value={api}>
			<BrowserRouter>
				<Redux>
					<AppLocalizationProvider>
						<App />
					</AppLocalizationProvider>
				</Redux>
			</BrowserRouter>
		</APIContext.Provider>
	</StrictMode>,
	document.getElementById('root')
);
